import './Loading.css';

const Loading = () => (
  <div className="container">
    <div className="slideshow">
      <div className="imgslide" />
    </div>
  </div>
);

export default Loading;
